import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(persist((set, get) => ({
  // State
  user: null,
  token: null,
  role: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,

  // Actions
  setUser: (user) => set({ user, isAuthenticated: !!user }),

  setToken: (token) => set({ token }),

  setRole: (role) => set({ role }),

  setLoading: (isLoading) => set({ isLoading }),

  setError: (error) => set({ error }),

  login: (user, token) => set({ user, token, isAuthenticated: true, error: null }),

  logout: () => {
    localStorage.removeItem('authToken');
    set({ user: null, token: null, role: null, isAuthenticated: false, error: null });
  },

  initializeAuth: () => {
    const token = localStorage.getItem('authToken');
    if (token) {
      set({ token, isAuthenticated: true });
      // Optionally fetch user data here
    }
  },
}), {
  name: 'auth',
}));